import { createAction, createActions } from 'redux-actions';

export const moduleName = 'auth';

export const SET_SESSION_STATUS = `${moduleName}/SET_SESSION_STATUS`;
export const RESET_AUTH_ERROR = `${moduleName}/RESET_AUTH_ERROR`;
export const SKIP_LOGIN_STEP = `${moduleName}/SKIP_LOGIN_STEP`;
export const GO_TO_NEXT_STEP_WHEN_LOGIN_IS_SKIPPED = `${moduleName}/GO_TO_NEXT_STEP_WHEN_LOGIN_IS_SKIPPED`;

export const { auth: { setSessionStatus } } = createActions({
  [SET_SESSION_STATUS]: payload => payload,
});

export const resetAuthError = createAction(RESET_AUTH_ERROR);

export const goToNextStepWhenLoginIsSkipped = createAction(GO_TO_NEXT_STEP_WHEN_LOGIN_IS_SKIPPED);
